<template>
    <section class="recipe-instructions">
        <div class="header-section">
            <h2
                class="title"
                v-test:title
            >
                {{ title }}
            </h2>
            <div
                v-if="subTitle.to"
                class="sub-title-container"
            >
                <nuxt-link
                    :to="subTitle.to"
                    class="sub-title"
                    v-test:subTitle
                >
                    {{ subTitle.name }}
                </nuxt-link>
            </div>
        </div>

        <ol class="step-list">
            <li
                v-for="(step, i) in steps"
                :key="`step_${ i }`"
                class="step-container"
            >
                <h2 class="step-title">step {{ i + 1 }}</h2>
                <markdown-content
                    :content="step.step"
                />
            </li>
        </ol>
    </section>
</template>

<script>
    import MarkdownContent from '../../utils/MarkdownContent/MarkdownContent';

    export default {
        name: 'recipe-instructions',

        components: { MarkdownContent },

        props: {
            title: {
                type: String,
                required: true,
            },

            steps: {
                type: Array,
                default: () => ([]),
            },

            subTitle: {
                type: Object,
                default: () => ({}),
            },
        },
    };
</script>

<style lang="scss" scoped>
    .recipe-instructions {
        background-color: secondary-palette(7);
        padding: 48px 24px;

        @include media-breakpoint-up(lg) {
            border-top-left-radius: 100px;
            border-bottom-left-radius: 100px;
            padding: 65px 75px;
        }

        @include media-breakpoint-up(xl) {
            padding: 65px 114px;
        }
    }

    .header-section {
        text-align: center;

        @include media-breakpoint-up(lg) {
            text-align: left;
        }
    }

    .title {
        font-size: rem(32px);
        font-weight: bold;
        padding-bottom: 20px;

        @include media-breakpoint-up(lg) {
            font-size: rem(45px);
        }
    }

    .sub-title-container {
        padding-bottom: 20px;
    }

    .sub-title {
        font-size: rem(24px);
        font-weight: bold;
        color: primary-palette(2);
        text-decoration: underline;
        text-decoration-thickness: 2px;

        @include media-breakpoint-up(lg) {
            font-size: rem(30px);
        }

        &:hover {
            color: primary-palette(1);
        }
    }

    .step-title {
        font-size: rem(24px);
        font-weight: bold;

        @include media-breakpoint-up(lg) {
            font-size: rem(30px);
        }
    }

    ::v-deep .markdown-content {
        p {
            font-size: rem(20px);
            font-weight: 300;
        }
    }

    .step-list {
        list-style-type: none;
        padding: 0;
    }
</style>
